import { LocationDto } from "@apiModels/LocationDto.csharp";
import { Filters } from "./types";

export function filterLocations(filters: Filters, locations: LocationDto[]) {
  const { specialization, service } = filters;

  if (!specialization) return locations;
  const locationsBySpecialization = locations.filter((location) =>
    location.specializations.includes(specialization.id)
  );

  if (service) {
    const locationsBySpecializationService = locationsBySpecialization.filter(
      (location) => {
        const serviceLocations = service.centerBookingOptions.map(
          (serviceLocation) => serviceLocation.centerId
        );
        return (
          serviceLocations.includes(location.id) ||
          (location.isLocation &&
            serviceLocations.some((serviceLocation) =>
              location.centers.includes(serviceLocation)
            ))
        );
      }
    );

    return locationsBySpecializationService;
  }

  return locationsBySpecialization;
}
